import { rem, spacing, styled, TextArea } from '@lessonup/ui-components';
import React from 'react';
import { FullPageBackground } from '../../../components/FullPageFlow/FullPageBackground';
import { Disclaimer } from '../Disclaimer';
import { useAiToolboxContext } from '../context/AiToolboxContext';
import { MissingFlagHelper } from './MissingFlagHelper';

interface DefaultToolWrapperProps {
  children: React.ReactNode;
}

export const DefaultToolWrapper: React.FC<DefaultToolWrapperProps> = ({ children }) => {
  const { showInline } = useAiToolboxContext();
  if (showInline) {
    return <>{children}</>;
  }

  return (
    <FullPageBackground>
      <Wrapper>
        <MissingFlagHelper>
          {children}
          <Disclaimer />
        </MissingFlagHelper>
      </Wrapper>
    </FullPageBackground>
  );
};

export const StyledTextArea = styled(TextArea)`
  width: 100%;
`;

export const FullWidth = styled.div`
  width: 100%;
`;

const Wrapper = styled.div`
  max-width: ${rem('672px')};
  margin: 0 auto;
  padding: 0 ${spacing.size16};
  width: 100%;

  @media print {
    max-width: 100%;
    padding: 0;
  }
`;
